import { getMarkup, assignMarkupPosition, getMarkupAttachment } from 'Domain/Mesh/Handler/MarkupHandler'
import { setMeshToLayer } from 'Domain/Scene/Handler/LayerHandler'

/*****************************************************************
 * Stripping HANDLER
 * ***************************************************************/

/**
 * Marker Store
 */
let markupStore = []

export const clearMarkupStore = () => {
    markupStore.forEach(markup => {
        if (markup.geometry) markup.geometry.dispose();
        if (markup.material) {
            if (markup.material.map) markup.material.map.dispose();
            markup.material.dispose();
        }
    });
    markupStore = [];
}

const 
    addMarkup = ( iprValue, inter, keyframe ) => new Promise ( resolve => {
        let markerName = 'Marker-'+inter+'-'+iprValue,
            marker,
            frame = parseInt(keyframe.substring(5))
        
        if ( markupStore.filter( mark => mark.name === markerName ).length === 0 ){
            marker = getMarkup( iprValue, inter ).then( markup => {
                markup.userData.keyframes.push( frame )
                markupStore.push( markup )
                return markup
            })
        } else {
            marker = markupStore.filter( mark => mark.name === markerName )[0]
            marker.userData.keyframes.push( frame )
        }

        resolve( marker )
    }),
    addLines = ( markup, iprCoords, lineMaterial, targetGroup ) => new Promise ( resolve => {
        let line = getMarkupAttachment( markup, iprCoords, targetGroup )
        line.material = lineMaterial
        markup.userData.line = line
        resolve( line )
    })

/**
 * Add all prepared marker to group
 * @param {object} group 
 */
export const addMarkerToGroup = group => group.children = markupStore

/**
 * Create marker and line ang add it to the target group
 * @param {object} strippingArchDatas 
 * @param {object} center 
 * @param {string} arch 
 * @param {object} linematerial 
 * @param {object} targetGroup - Le groupe cible où ajouter les markups
 */
export const addMarkups = ( strippingArchDatas, center, arch, lineMaterial, targetGroup ) => {
    let jaw = (arch === 'U') ? 'iprUpper' : 'iprLower',
    archesCount = Object.keys(strippingArchDatas).length
    arch = (arch === 'U') ? 'maxi' : 'mandi'

    if(strippingArchDatas[jaw])
        Object.entries(strippingArchDatas[jaw]).forEach( ([ keyframe, interdentalEntries ]) => {
            if( interdentalEntries )
                Object.entries(interdentalEntries).forEach( ([inter, datas]) => {
                    if ( datas.iprValue )
                        addMarkup( 
                            parseFloat(datas.iprValue).toFixed(2), 
                            inter, 
                            keyframe 
                            ).then( marker => {
                                if( marker ){
                                    assignMarkupPosition( marker, datas.iprCoords, center, arch, archesCount, targetGroup )
                                    addLines( marker, datas.iprCoords, lineMaterial, targetGroup ).then( line => {
                                        setMeshToLayer( marker, arch )
                                        setMeshToLayer( line, arch )
                                        // Ajouter directement au groupe cible au lieu de markupStore
                                        targetGroup.add(marker)
                                        targetGroup.add(line)
                                    } )
                                }
                            })
                })
        })

}
